// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.settings-container h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 24px;
}

.settings-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
  overflow-x: auto;
}

.settings-tab {
  background: none;
  border: none;
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin-bottom: -2px;
}

.settings-tab:hover {
  color: #667eea;
  background: #f9fafb;
}

.settings-tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
}

.settings-content {
  min-height: 400px;
}

.settings-placeholder {
  padding: 60px 20px;
  text-align: center;
  color: #6b7280;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .settings-container {
    padding: 16px;
  }

  .settings-container h2 {
    font-size: 1.5rem;
  }

  .settings-tabs {
    gap: 4px;
  }

  .settings-tab {
    padding: 10px 16px;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".settings-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.settings-container h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 24px;\n}\n\n.settings-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid #e5e7eb;\n  overflow-x: auto;\n}\n\n.settings-tab {\n  background: none;\n  border: none;\n  padding: 12px 20px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  margin-bottom: -2px;\n}\n\n.settings-tab:hover {\n  color: #667eea;\n  background: #f9fafb;\n}\n\n.settings-tab.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n}\n\n.settings-content {\n  min-height: 400px;\n}\n\n.settings-placeholder {\n  padding: 60px 20px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n@media (max-width: 768px) {\n  .settings-container {\n    padding: 16px;\n  }\n\n  .settings-container h2 {\n    font-size: 1.5rem;\n  }\n\n  .settings-tabs {\n    gap: 4px;\n  }\n\n  .settings-tab {\n    padding: 10px 16px;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
